import React from "react";
import { Helmet } from "react-helmet";
import "../css/privacy-policy.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Rising Cab Service</title>

        <meta
          name="description"
          content="Privacy Policy for Rising Cab Service. Learn how we collect, use, and protect your personal information when using our cab booking, airport transfer, local and outstation travel services."
        />

        <meta
          name="keywords"
          content="Rising Cab Service, Cab Service, Taxi Booking, Airport Transfer, Outstation Travel, Privacy Policy"
        />
      </Helmet>

      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1,
          }}
        ></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Privacy Policy</h1>
          </div>
        </div>
      </div>

      {/* Privacy Policy Section */}
      <section className="privacy-policy">
        <div className="container px-0">

          <div className="row g-0">
            <img src="/images/privacy.png" alt="Privacy Rising Cab Service" />

            <div className="col-12 col-md-12">
              <h3 className="title">Privacy Policy – Rising Cab Service</h3>

              <p>
                At <b>Rising Cab Service</b>, we respect your privacy and are committed to
                protecting your personal information. This Privacy Policy explains
                how we collect, use, and safeguard your data when you use our ride services.
              </p>

              {/* Information We Collect */}
              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>

                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  Name, mobile number, email address, pickup and drop locations,
                  travel dates, and payment details when you book a ride.
                </p>

                <p className="highlight darkcolor">2. Booking Information:</p>
                <p>
                  Ride details including routes, vehicle type, passenger count,
                  and destination to ensure smooth service.
                </p>

                <p className="highlight darkcolor">3. Device & Usage Data:</p>
                <p>
                  We may collect device information, browser type, IP address,
                  and website usage data to improve our services.
                </p>
              </div>

              {/* How We Use Information */}
              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>

                <p className="highlight darkcolor">1. Booking & Service Delivery:</p>
                <p>
                  To process bookings, assign drivers, and complete rides efficiently.
                </p>

                <p className="highlight darkcolor">2. Customer Support:</p>
                <p>
                  To provide booking confirmations, updates, invoices, and support.
                </p>

                <p className="highlight darkcolor">3. Service Improvement:</p>
                <p>
                  To analyze feedback and improve ride experience and operations.
                </p>

                <p className="highlight darkcolor">4. Marketing:</p>
                <p>
                  With consent, we may send offers and updates. You can opt out anytime.
                </p>
              </div>

              {/* Information Sharing */}
              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>

                <p className="highlight darkcolor">1. Drivers:</p>
                <p>
                  Necessary booking details are shared with drivers for ride execution.
                </p>

                <p className="highlight darkcolor">2. Service Providers:</p>
                <p>
                  We may share limited data with payment gateways and trusted partners.
                </p>

                <p className="highlight darkcolor">3. Legal Requirements:</p>
                <p>
                  Information may be shared when required by law or authorities.
                </p>
              </div>

              {/* Security */}
              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We use industry-standard security measures to protect your data.
                </p>

                <p className="highlight darkcolor">Data Retention:</p>
                <p>
                  Data is stored only as long as needed for service and legal compliance.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You can request access, correction, or deletion of your personal data.
                </p>

                <p className="highlight darkcolor">Cookies:</p>
                <p>
                  Our website uses cookies to improve user experience and analytics.
                </p>

                <p className="highlight darkcolor">Third-Party Links:</p>
                <p>
                  We are not responsible for external websites linked from our platform.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  This Privacy Policy may be updated periodically.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Rising Cab Service</h2>

            <p>
              For any privacy-related queries, contact us:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919272511548">+91 9272511548</a>
              </li>

              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@risingcabservice.com">
                  booking@risingcabservice.com
                </a>
              </li>

              <li>
                <b>Address:</b>
                <br />
                Rising Cab Services,<br />
                A Unit of Atithya Dining LLP,<br /> 901, 902 Deron Height,<br /> Baner Rd, Above Ranka Jewelers, <br />Pune, Maharashtra - 411069
              </li>
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;